import { Box, Button, Typography } from '@mui/material';

function AppErrorFallback() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100dvh"
      gap={2}
      px={2}
      textAlign="center">
      <Typography variant="h2">Something went wrong</Typography>
      <Typography variant="body2">
        Reloading the page usually fixes this.
      </Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Box>
  );
}

export default AppErrorFallback;
